export default __webpack_public_path__ + "/dist/images/2225223.65bf09d6b9a9f1f1b06c028bd8782024.png";